<template>
  <div>
    <input
      @keydown.space="event => event.preventDefault()"
      type="text"
      :readonly="redeemed"
      :placeholder="$t('Redeem Code')"
      maxlength="30"
      name="redeem"
      v-model="redeem"
      style="text-transform: uppercase;"
    />
    <div v-if="!showMoreCode">
      <v-btn color="primary" small flat @click="showMoreCode = true">
        {{ $t('If you have more than a code, click here') }}
        <v-icon>{{ showMoreCode ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
      </v-btn>
    </div>

    <template v-else>
      <input
        type="text"
        :readonly="redeemed"
        :placeholder="$t('Redeem Code') + '2'"
        maxlength="30"
        name="redeem"
        v-model="redeem2"
        style="text-transform: uppercase;"
      />
      <input
        type="text"
        :readonly="redeemed"
        :placeholder="$t('Redeem Code') + '3'"
        maxlength="30"
        name="redeem"
        v-model="redeem3"
        style="text-transform: uppercase;"
      />
      <input
        type="text"
        :readonly="redeemed"
        :placeholder="$t('Redeem Code') + '4'"
        maxlength="30"
        name="redeem"
        v-model="redeem4"
        style="text-transform: uppercase;"
      />
    </template>
    <v-btn
      outline
      @click="showInfo"
      :loading="redeemloading"
      :disabled="redeemloading || redeemed || !hasRedeemCode"
      color="primary"
      >{{ $t('Activate') }}</v-btn
    >
    <v-dialog v-model="showPayment" max-width="1040">
      <payment-form
        v-model="input"
        :params="'btn_redeemcode_fb'"
        @onSave="saveData"
        @onCancel="showPayment = false"
        :loading="redeemloading"
      >
        <div slot="footer" class="text-xs-center" slot-scope="scope">
          <v-btn class dark color="primary" @click="scope.saveData()" :loading="loading">{{
            $t('Save')
          }}</v-btn>
        </div>
      </payment-form>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PaymentForm from '@/components/elements/PaymentForm'

import dayjs from 'dayjs'

import minMax from 'dayjs/plugin/minMax'

export default {
  prop: ['blockInput'],
  data() {
    return {
      showPayment: false,
      redeem: '',
      redeem2: '',
      redeem3: '',
      redeem4: '',
      redeemloading: false,
      loading: false,
      redeemed: false,
      showMoreCode: false,
      input: {
        age: null,
        phoneno: '',
        province: '',
        email: '',
        business_type: '',
        suggest: '',
        reason_to_buy: '',
        suggest_other: '',
        locale: '',
        source: 'CMS',
        contact: ''
      },
      input_cache: '',
      pack: 'redeem code',
      isBlockInput: false
    }
  },
  async mounted() {
    dayjs.extend(minMax)
    this.isBlockInput = this.blockInput || false
    this.supportCodeActivate()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    hasRedeemCode() {
      return this.redeem || this.redeem2 || this.redeem3 || this.redeem4
    },
    hasZWIZAICHATBOT() {
      return (
        (this.redeem && this.redeem == 'ZWIZAICHATBOT') ||
        (this.redeem2 && this.redeem2 == 'ZWIZAICHATBOT') ||
        (this.redeem3 && this.redeem3 == 'ZWIZAICHATBOT') ||
        (this.redeem4 && this.redeem4 == 'ZWIZAICHATBOT')
      )
    }
  },
  components: {
    PaymentForm
  },
  methods: {
    async showInfo() {
      if (this.hasZWIZAICHATBOT) {
        this.saveData()
      } else {
        this.showPayment = true
        await this.getInfo()
      }
    },
    onSaveRedeem(code) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = { pageid: this.selectedBot.pageid, redeem: code.toUpperCase() }
        api.activateredeemcode(data, function(error, response) {
          if (response.responsecode == 200) {
            if (response.hasOwnProperty('extend')) {
              response.isPass = true
              response.code = code
              resolve(response)
            } else {
              response.isPass = false
              response.code = code
              resolve(response)
            }
          } else if (response.responsecode == 401) {
            response.isPass = false
            response.code = code
            resolve(response)
          }
        })
      })
    },
    getInfo() {
      var vm = this

      return new Promise((resolve, reject) => {
        let data = { pageid: vm.selectedBot.pageid, type: 'redeemcode/supportcode', package: '' }
        vm.redeemloading = true

        api.getInfocustomerspremium(data, (error, response) => {
          if (error) console.error(error)

          if (response.data.length) {
            Object.assign(vm.input, response.data[0])
          }
          vm.errors.clear()
          vm.redeemloading = false
          resolve()
        })
      })
    },
    supportCodeActivate() {
      var vm = this
      if (vm.$route.query.hasOwnProperty('supportcode')) {
        var data = {
          pageid: vm.selectedBot.pageid,
          supportcode: vm.$route.query.supportcode.toUpperCase()
        }
        api.saveSupportusers(data, function(error, response) {
          if (error) {
            console.error(error)
            return
          }

          if (response.data) {
            vm.$swal
              .fire({
                title: vm.$t('Successfully'),
                text: vm.$t('you got {day} days for using Premium Package', {
                  day: response.freetrial
                }),
                type: 'success'
              })
              .then(result => {
                location.reload()
                // if (result.value) {
                //   // vm.$emit('updateSupportCode')
                // }
              })
          }
        })
      }
    },
    async saveData() {
      this.redeemloading = true
      this.loading = true
      this.input.locale = this.$store.state.currentLang
      this.input.type = 'redeemcode'
      this.input.facebook_name = this.$store.state.facebook_name
      this.input.pagename = this.selectedBot.pagename
      let data = {
        pageid: this.$store.state.selectedBot.pageid,
        obj: this.input
      }
      let promiseRedeems = []
      if (this.redeem && this.redeem != '') {
        promiseRedeems.push(this.onSaveRedeem(this.redeem))
      }
      if (this.redeem2 && this.redeem2 != '') {
        promiseRedeems.push(this.onSaveRedeem(this.redeem2))
      }
      if (this.redeem3 && this.redeem3 != '') {
        promiseRedeems.push(this.onSaveRedeem(this.redeem3))
      }
      if (this.redeem4 && this.redeem4 != '') {
        promiseRedeems.push(this.onSaveRedeem(this.redeem4))
      }

      const results = await Promise.all(promiseRedeems.map(p => p.catch(e => e)))
      const validResults = results.filter(result => !(result instanceof Error))
      const errorResults = results.filter(result => result instanceof Error)

      try {
        if (validResults.length > 0) {
          var premium_day = 0,
            advanced_day = 0
          var latest_date = []
          var redeemResponse = validResults.filter(
            result => result.responsecode == 200 && result.isPass
          )
          var disableResponse = validResults.filter(
            result => result.responsecode == 401 || (result.responsecode == 200 && !result.isPass)
          )
          if (redeemResponse.length > 0) {
            var postInfoPromise = []
            validResults.map(el => {
              latest_date.push(dayjs(el.expireat))
              data.package = el.isPass ? el.code : '-'
              if (el.package_type == 'premium') {
                premium_day += parseInt(el.extend)
                Object.assign(data, { obj: { ...data.obj, type: el.type } })
              } else if (el.package_type == 'advanced') {
                advanced_day += parseInt(el.extend)
                Object.assign(data, { obj: { ...data.obj, type: el.type } })
              }
              if (!this.hasZWIZAICHATBOT) {
                postInfoPromise.push(this.postInfocustomerspremium(data))
              }
            })

            await Promise.all(postInfoPromise)
            if (advanced_day + premium_day > 0) {
              await this.$swal.fire({
                type: 'success',
                html:
                  (advanced_day > 0
                    ? `<div>
                  ${this.$t('you got 15 days Advanced Package', {
                    day: advanced_day
                  })}
                </div>`
                    : '') +
                  (premium_day > 0
                    ? `<div>
                  ${this.$t('you got 15 days Premium Package', {
                    day: premium_day
                  })}
                </div>`
                    : '') +
                  `<div>${this.$t('Expired Date')} ${dayjs
                    .max(latest_date)
                    .format('DD/MM/YYYY')}</div>`
              })
            }
            location.reload()
          }
          if (disableResponse.length > 0) {
            let time = disableResponse[0].unlocktimestamp
            var postFailInfoPromise = []
            disableResponse.map(el => {
              data.package = el.isPass ? el.code : '-'
              data.obj.type = 'redeemcode/supportcode'
              if (!this.hasZWIZAICHATBOT) {
                postFailInfoPromise.push(this.postInfocustomerspremium(data))
              }
            })
            let reason = disableResponse[0].reason || this.$t('Error')
            await Promise.all(postFailInfoPromise)
            await this.$swal.fire({
              type: 'error',
              title: time ? this.$t('This page has too many attempt') : reason,
              text:
                this.$t(`Please try again after`) +
                ' ' +
                (time ? dayjs(time).format('DD/MM/YYYY HH:mm') : '')
            })
            this.$localStorage.set('redeemlock', time)
            this.loading = false
          }
          if (this.isBlockInput) {
            this.redeemed = true
          }
        }
        if (errorResults.length > 0) {
          // data.package = 'กรอก Redeem Code ไม่สำเร็จ'
          // await this.postInfocustomerspremium(data)
          await this.$swal.fire({
            type: 'error',
            title: this.$t(errorResults[0].message)
          })
        }
      } catch (error) {
        console.error(error)
      }

      this.showPayment = false
      this.redeemloading = false
    },
    postInfocustomerspremium(data) {
      return new Promise((resolve, reject) => {
        api.postInfocustomerspremium(data, (error, response) => {
          if (error) reject(error)
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/RedeemCode.vue